<ng-template #template let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{ "label-title.cancellation-policy" | translate }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                (click)="closeModal()"></button>
        </div>
        <div class="modal-body cancellation-policy-list">
            <div class="d-flex justify-content-center align-items-center mb-3">
                <img src="../../../../assets/images/default-images/cancellation-policy.svg" width="100" height="100"
                    alt="policy" />
            </div>
            @for(policy of cancellationPolicy; track $index){
            <div class="mb-3 bg-light rounded">
                <div class="p-3">
                    <p class="mb-0 fw-medium">{{ policy }}</p>
                </div>
            </div>
            }
        </div>
    </div>
</ng-template>